module.exports = __webpack_public_path__ + "static/img/horn.c2104164.svg";